export default "__VITE_ASSET__Cattfpcj__"